// src/pages/Dashboard/components/ChartCard.jsx
import React, { memo } from "react";

/**
 * Thin layout wrapper around a recharts ResponsiveContainer. Memoized so
 * unrelated dashboard updates don't re-render every chart card.
 */
function ChartCard({ title, children }) {
  return (
    <div className="sd-chart-card">
      <h2>{title}</h2>
      {children}
    </div>
  );
}

export default memo(ChartCard);
